// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

import { Liquid } from "@Obsidian/Libs/liquidjs";

const engine = new Liquid({
    cache: true
});

const hasLavaCommandFieldsRegex: RegExp = /\{%.+%\}/;
const hasLavaShortcodeFieldsRegex: RegExp = /\{\[.+\]\}/;

export function resolveMergeFields(template: string, mergeFields: Record<string, unknown>): string {
    const tpl = engine.parse(template);

    return engine.renderSync(tpl, mergeFields);
}

/** Determines whether the string potentially has lava command {% %} fields in it. */
export function hasLavaCommandFields(template: string): boolean {
    return hasLavaCommandFieldsRegex.test(template);
}

/** Determines whether the string potentially has lava shortcode {[ ]} fields in it. */
export function hasLavaShortcodeFields(template: string): boolean {
    return hasLavaShortcodeFieldsRegex.test(template);
}